// コンテンツ読み込み後
$(document).ready(function() {
    // toアドレス追加
    $(document).on('click', '[data-append-to_emails]', function () {
        initializeEmailSortable('to_emails');
        toIndex++;
        let emailInput = getInputEmail('mail-setting-modal-to_emails_' + toIndex, 'to_emails[' + toIndex + ']');
        $('#to_emails-wrapper').append(emailInput);
        reindexEmails('to_emails');
    });

    // ccアドレス追加
    $(document).on('click', '[data-append-cc_emails]', function () {
        initializeEmailSortable('cc_emails');
        ccIndex++;
        let emailInput = getInputEmail('mail-setting-modal-cc_emails_' + ccIndex, 'cc_emails[' + ccIndex + ']');
        $('#cc_emails-wrapper').append(emailInput);
        reindexEmails('cc_emails');
    });

    // アドレス削除
    $(document).on('click', '[data-remove]', function () {
        let wrapper = $(this).closest('.email-address-wrapper');
        $(this).closest('.email-address').remove();
        if (wrapper.attr('id') == 'to_emails-wrapper') {
            reindexEmails('to_emails');
        }
        if (wrapper.attr('id') == 'cc_emails-wrapper') {
            reindexEmails('cc_emails');
        }
    });

    $(document).on('mouseenter mousedown touchstart', '#to_emails-wrapper, #cc_emails-wrapper', function () {
        initializeEmailSortable($(this).attr('id').replace('-wrapper', ''));
    });

    // エレメント作成
    function getInputEmail(id, name) {
        return $(`<div class="email-address">
                    <span class="badge-draggable email-drag-handle" title="ドラッグして並び替え">↔︎</span>
                    <input type="email" id="${id}" class="multi-error" name="${name}" />
                    <span class="remove-button" data-remove>削除</span>
                    <div class="" id="${id}-errors">
                        <span class="invalid-feedback copy" role="alert"></span>
                    </div>
                </div>
                `);
    }

    function initializeEmailSortable(name) {
        let wrapper = $('#' + name + '-wrapper');
        let dataKey = name + '-sortable-initialized';

        if (wrapper.length == 0 || wrapper.data(dataKey)) {
            return;
        }

        if (wrapper.hasClass('ui-sortable')) {
            wrapper.sortable('destroy');
        }

        wrapper.sortable({
            handle: '.email-drag-handle',
            items: '.email-address',
            tolerance: 'pointer',
            placeholder: 'email-address border border-primary bg-light',
            update: function () {
                reindexEmails(name);
            },
        });
        wrapper.data(dataKey, true);
    }

    function reindexEmails(name) {
        $('#' + name + '-wrapper .email-address').each(function (index) {
            let id = 'mail-setting-modal-' + name + '_' + index;

            $(this).find('[name^="' + name + '["]').attr({
                id: id,
                name: name + '[' + index + ']',
            });
            $(this).find('[id$="-errors"]').attr('id', id + '-errors');
        });

        if (name == 'to_emails') {
            toIndex = $('#to_emails-wrapper .email-address').length - 1;
        }
        if (name == 'cc_emails') {
            ccIndex = $('#cc_emails-wrapper .email-address').length - 1;
        }
    }
});
